"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getJoiObjectKeys(schema) {
    if (typeof schema.$_terms === "object" &&
        typeof schema.$_terms.keys === "object") {
        return schema.$_terms.keys.map(function (e) { return e.key; }); // for Joi >= 16
    }
    return schema._inner.children.map(function (e) { return e.key; }); // For Joi <= 15
}
exports.getJoiObjectKeys = getJoiObjectKeys;
